import { data } from "jquery";
import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/question/store",
    data: data,
  });
};
export const FormSubmitCategory = async data => {
  await Set({
    url: "/questioncategory/store",
    data: data,
  });
};
export const FormSubmitGeneral = async data => {
  return await Set({
    url: "/setting/general",
    data: data,
  });
};
export const FormSubmitCompany = async data => {
  return await Set({
    url: "/setting/company",
    data: data,
  });
};
export const FormSubmitSite = async data => {
  return await Set({
    url: "/setting/site",
    data: data,
  });
};
export const GetData = async (limit = 15, page = null) => {
  return await Get({
    url: "/category/show_all",
    data: {
      limit: limit,
    },
    page: page,
  }).then(data => {
    return data;
  });
};
export const GetQuestion = async pageNumber => {
  return await Get({
    url: "/question/show",
    page: pageNumber,
  }).then(data => {
    return data;
  });
};
export const GetCategoryQuestion = async pageNumber => {
  return await Get({
    url: "/questioncategory/show",
    page: pageNumber,
  }).then(data => {
    return data;
  });
};
export const GetSiteData = async () => {
  return await Get({
    url: "/setting/site_show",
  }).then(data => {
    return data;
  });
};
export const GetCompanyData = async () => {
  return await Get({
    url: "/setting/company_show",
  }).then(data => {
    return data;
  });
};
export const GetGenralData = async () => {
  return await Get({
    url: "/setting/general_show",
  }).then(data => {
    return data;
  });
};
export const DeleteData = async data => {
  await Remove({
    url: "/question/destroy",
    data: data,
  });
};
export const DeleteDataCategory = async data => {
  await Remove({
    url: "/questioncategory/destroy",
    data: data,
  });
};
//

export const EditData = async data => {
  await Set({
    url: "/category/update",
    data: data,
  });
};

export const ShowData = (data, key) => {
  let result = "";
  if (data) {
    data.filter(data => {
      if (data.key == key) {
        result = data.value;
      }
    });
  }
  return result;
};
export const checkEmpty = data => {
  switch (data) {
    case null:
    case undefined:
    case " ":
      return false;

    default:
      return true;
  }
};
//

export const SubmitReward = async data => {
  await Get({
    url: "/setting/invateandpoint",
    data: { ...data },
    stat: true,
  });
};
//
export const GetReward = async data => {
  return await Get({
    url: "/setting/invateandpoint_show",
  }).then(data => {
    return data;
  });
};

export const SubmitRating = async data => {
  await Get({
    url: "/setting/rating_edit",
    data: { ...data },
    stat: true,
  });
};
export const Submitclup = async data => {
  await Set({
    url: "/setting/rating_edit",
    data: { ...data },
  });
};
//
export const GetRating = async data => {
  return await Get({
    url: "/setting/rating_show",
  }).then(data => {
    return data;
  });
};
export const EditDataCategory = async data => {
  await Set({
    url: "/questioncategory/update",
    data: data,
  });
};
